import { createClient } from "@sanity/client";

export const clientCMSvelas = createClient({
  projectId: "y3h5jprs",
  dataset: process.env.REACT_APP_SANITY_DATASET,
  apiVersion: "2024-01-01",
  useCdn: false,
  token: process.env.REACT_APP_SANITY_API_TOKEN,
  ignoreBrowserTokenWarning: true,
});
